export const OptionSerializer = option => {
  const { feedbackOptionId, other_text, files, products } = option;

  return {
    option: parseInt(feedbackOptionId, 10),
    files,
    products,
    ...option.telemetry,
    ...(other_text && { other_text }),
  };
};
